import {Filter, RotateCcw} from "lucide-react";
import {useTranslation, i18n} from "../../../shared/i18n";


const STATUS_OPTIONS = [
    {value: "", get label() { return i18n.t("sections.onboarding.p159"); }},
    {value: "draft", get label() { return i18n.t("sections.onboarding.p160"); }},
    {value: "under_moderation", get label() { return i18n.t("sections.onboarding.p161"); }},
    {value: "documents_required", get label() { return i18n.t("sections.onboarding.p162"); }},
    {value: "published", get label() { return i18n.t("sections.onboarding.p163"); }},
    {value: "rejected", get label() { return i18n.t("sections.onboarding.p164"); }},
    {value: "limited_financial_activation", get label() { return i18n.t("sections.onboarding.p165"); }},
    {value: "fully_verified", get label() { return i18n.t("sections.onboarding.p166"); }},
    {value: "activated", get label() { return i18n.t("sections.onboarding.p167"); }},
    {value: "disabled", get label() { return i18n.t("sections.onboarding.p168"); }},
];

const FLOW_OPTIONS = [
    {value: "", get label() { return i18n.t("sections.onboarding.p169"); }},
    {value: "independent", get label() { return i18n.t("sections.onboarding.p51"); }},
    {value: "sales_invite", get label() { return i18n.t("sections.onboarding.p52"); }},
];

const FilterField = ({label, children, className = ""}) => (
    <label className={`admin-field onboarding-filter-field ${className}`.trim()}>
        <span>{label}</span>
        {children}
    </label>
);

export const QueueFilters = ({
    draftFilters,
    setDraftFilters,
    onApply,
    onReset,
    error,
    busy,
}) => {
    const {t} = useTranslation();
    const update = (field) => (event) => {
        const value = event.target.value;
        setDraftFilters((current) => ({...current, [field]: value}));
    };

    const submit = (event) => {
        event.preventDefault();
        onApply();
    };

    return (
        <form
            className="onboarding-filter-panel"
            aria-label={t("sections.onboarding.p170")}
            aria-busy={busy}
            onSubmit={submit}
            noValidate
        >
            <div className="onboarding-filter-grid">
                <FilterField label={t("sections.onboarding.p62")}>
                    <select value={draftFilters.status} onChange={update("status")}>
                        {STATUS_OPTIONS.map((option) => (
                            <option key={option.value || "all"} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </FilterField>
                <FilterField label={t("sections.onboarding.p60")}>
                    <select value={draftFilters.flow_type} onChange={update("flow_type")}>
                        {FLOW_OPTIONS.map((option) => (
                            <option key={option.value || "all"} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </FilterField>
                <FilterField label={t("sections.onboarding.p171")} className="onboarding-filter-search">
                    <input
                        type="search"
                        maxLength={120}
                        placeholder={t("sections.onboarding.p172")}
                        value={draftFilters.search}
                        onChange={update("search")}
                    />
                </FilterField>
                <FilterField label={t("sections.onboarding.p173")}>
                    <input
                        type="date"
                        value={draftFilters.submitted_from}
                        onChange={update("submitted_from")}
                    />
                </FilterField>
                <FilterField label={t("sections.onboarding.p174")}>
                    <input
                        type="date"
                        value={draftFilters.submitted_to}
                        onChange={update("submitted_to")}
                    />
                </FilterField>
                <button
                    className="admin-button admin-button-primary onboarding-filter-command"
                    type="submit"
                    disabled={busy}
                >
                    <Filter aria-hidden="true" size={16} />
                    {t("sections.onboarding.p175")}
                </button>
                <button
                    className="admin-button admin-button-secondary onboarding-filter-command"
                    type="button"
                    onClick={onReset}
                    disabled={busy}
                >
                    <RotateCcw aria-hidden="true" size={16} />
                    {t("sections.onboarding.p176")}
                </button>
            </div>
            <div className="onboarding-filter-message" aria-live="polite">
                {error ? <p role="alert">{error}</p> : null}
            </div>
        </form>
    );
};
